import { render, staticRenderFns } from "./edit-topic-group.vue?vue&type=template&id=35d28915"
import script from "./edit-topic-group.ts?vue&type=script&lang=js&external"
export * from "./edit-topic-group.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports